var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M9.07763 0.702202C9.42034 -0.116037 10.5797 -0.116038 10.9224 0.7022L12.9535 5.55165C13.0977 5.89588 13.4215 6.13119 13.7935 6.16193L19.0332 6.59509C19.9173 6.66818 20.2756 7.77075 19.6033 8.34953L15.6188 11.7798C15.336 12.0233 15.2123 12.404 15.298 12.7673L16.5052 17.8844C16.7089 18.7478 15.771 19.4293 15.0128 18.9687L10.5191 16.2393C10.2002 16.0456 9.79984 16.0456 9.48087 16.2393L4.9872 18.9687C4.229 19.4293 3.2911 18.7478 3.49479 17.8844L4.702 12.7673C4.7877 12.404 4.66399 12.0233 4.38116 11.7798L0.396711 8.34953C-0.275577 7.77075 0.0826712 6.66818 0.966765 6.59509L6.20652 6.16193C6.57846 6.13119 6.90233 5.89588 7.0465 5.55165L9.07763 0.702202Z",
    fill: "#78FD85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarActive);
export default __webpack_public_path__ + "static/media/star-active.9aee0b63914967b37c6ee796bf7924ab.svg";
export { ForwardRef as ReactComponent };